import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import DisplayCard from './DisplayCard';

const Block = (props) => {
  const {
    data, // Now contains: { statusName: "Ongoing Projects", count: 0 }
    handleQuickStatus,
    loading: parentLoading,
    selectedValue,
  } = props;

  const { statusName, count } = data || {};
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    setSelected(selectedValue === statusName);
  }, [selectedValue, statusName]);

  const handleClick = () => {
    if (typeof handleQuickStatus === 'function') {
      handleQuickStatus(statusName);
    }
  };

  // Match previous styling: make the "Required Action" tile red.
  const isActionRequired =
    typeof statusName === 'string' &&
    statusName.toLowerCase().includes('required');
  const textColor = isActionRequired ? '#F44336' : 'inherit';

  return (
    <DisplayCard
      tertiaryText={null}
      secondaryText={statusName || ''}
      primaryText={count !== null && count !== undefined ? String(count) : '0'}
      primaryTextColor={textColor}
      secondaryTextColor={textColor}
      loading={parentLoading || false}
      selected={selected}
      handleClick={handleClick}
    />
  );
};

export default Block;

